"use client"

import Text from "@/components/common/Typography/Text"
import Title from "@/components/common/Typography/Title"
import PromoDuration from "@/components/layouts/BasicLayout/BasicLayoutPromoBar/PromoDuration"
import { useAppSelector } from "@/hooks/redux"
import { Discount } from "@/lib/redux/features/store/type"
import { formatCurrencyUSD } from "@/utils/app/formatCurrencyUSD"
import { Col, Row, Typography } from "antd"
import dayjs from "dayjs"
import { useRef, useState } from "react"

const ProductPromo = ({ discountDetail }: { discountDetail: Discount | null }) => {
  const refInit = useRef<boolean>(false)
  const discountEndDate = discountDetail?.end_date
  const [shownPromo, setShownPromo] = useState<boolean>(false)

  if (!refInit.current) {
    if (!discountEndDate) {
      setShownPromo(false)
    } else {
      const now = dayjs()
      const endDate = dayjs(discountEndDate)
      const duration = endDate.diff(now, 'second')
      setShownPromo(duration > 30)
    }
    refInit.current = true
  }

  if (!shownPromo) {
    return <></>
  }

  return (
    <Row align='middle' justify='center' style={{ marginInline: '-0.5rem' }}>
      <Col style={{ paddingInline: '0.5rem' }}>
        <Row>
          <Title type='warning' level={3} style={{ margin: 0 }}>
            Save {discountDetail?.discount_type === 'amount' ? formatCurrencyUSD.format(parseFloat(discountDetail.discount_values || "0")) : `${parseFloat(discountDetail?.discount_values || "0")}%`}
          </Title>
        </Row>
        <Row>
          <Text type='warning'>
            for the next:
          </Text>
        </Row>
      </Col>
      <Col style={{ paddingInline: '0.5rem' }}>
        {!!discountDetail && (<PromoDuration type='full' textType='warning' discount={discountDetail} onEnded={() => setShownPromo(false)} />)}
      </Col>
    </Row>
  )
}

export default ProductPromo